import { Component, OnInit } from "@angular/core";
import { Router } from "@angular/router";

@Component({
  selector: "app-strategy",
  templateUrl: "./strategy.component.html",
  styleUrls: ["./strategy.component.css"],
})
export class StrategyComponent implements OnInit {
  constructor(public router: Router) {}

  ngOnInit(): void {
    document.documentElement.style.setProperty(
      "--color",
      !(this.router.url === "/home" || this.router.url === "/")
        ? "black"
        : "white"
    );
  }
}
